/**
 * Uploaded assets are already resized to WebP by /api/uploads and carry a
 * long-lived immutable cache header. Passing them through Next's optimizer a
 * second time adds latency and CPU work without improving the result.
 */
export function isPublicUploadUrl(value: string | undefined): boolean {
  return Boolean(value?.startsWith("/api/uploads/"));
}
